import script from "./CurrencyExchanger.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrencyExchanger.vue?vue&type=script&setup=true&lang=js"

import "./CurrencyExchanger.vue?vue&type=style&index=0&id=628555e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-628555e8"]])

export default __exports__